var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7929 15H21.5C21.2239 15 21 15.2239 21 15.5V24.5C21 24.7761 21.2239 25 21.5 25H23H27H28.5C28.7761 25 29 24.7761 29 24.5V19.2071C29 19.0745 28.9473 18.9473 28.8536 18.8536L25.1464 15.1464C25.0527 15.0527 24.9255 15 24.7929 15Z",
    fill: "#2C963D",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5V24.5C9 24.7761 9.22386 25 9.5 25H11H15H20.5C20.7761 25 21 24.7761 21 24.5V15.5V12.5C21 12.2239 20.7761 12 20.5 12H9.5C9.22386 12 9 12.2239 9 12.5Z",
    fill: "#2C963D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5V12.5C21 12.2239 20.7761 12 20.5 12H9.5C9.22386 12 9 12.2239 9 12.5V24.5C9 24.7761 9.22386 25 9.5 25H11H15H20.5C20.7761 25 21 24.7761 21 24.5ZM21 24.5V15.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 25C15.0001 26.1046 14.1047 27 13.0001 27C11.8955 27 11.0001 26.1046 11.0001 25C11.0001 23.8954 11.8955 23 13.0001 23C14.1047 23 15.0001 23.8954 15.0001 25Z",
    fill: "#2C963D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0001 25C27.0001 26.1046 26.1047 27 25.0001 27C23.8955 27 23.0001 26.1046 23.0001 25C23.0001 23.8954 23.8955 23 25.0001 23C26.1047 23 27.0001 23.8954 27.0001 25Z",
    fill: "#2C963D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 24.5V12.5C21.0001 12.2239 20.7762 12 20.5001 12H9.50009C9.22395 12 9.00009 12.2239 9.00009 12.5V24.5C9.00009 24.7761 9.22395 25 9.50009 25H11.0001M21.0001 24.5C21.0001 24.7761 20.7762 25 20.5001 25H15.0001M21.0001 24.5V15.5C21.0001 15.2239 21.2239 15 21.5001 15H24.793C24.9256 15 25.0528 15.0527 25.1465 15.1464L28.8536 18.8536C28.9474 18.9473 29.0001 19.0745 29.0001 19.2071V24.5C29.0001 24.7761 28.7762 25 28.5001 25H27.0001M21.0001 24.5C21.0001 24.7761 21.2239 25 21.5001 25H23.0001M11.0001 25C11.0001 26.1046 11.8955 27 13.0001 27C14.1047 27 15.0001 26.1046 15.0001 25M11.0001 25C11.0001 23.8954 11.8955 23 13.0001 23C14.1047 23 15.0001 23.8954 15.0001 25M23.0001 25C23.0001 26.1046 23.8955 27 25.0001 27C26.1047 27 27.0001 26.1046 27.0001 25M23.0001 25C23.0001 23.8954 23.8955 23 25.0001 23C26.1047 23 27.0001 23.8954 27.0001 25",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.14044f5ad8717a763ff5e4dc0f328d78.svg";
export { ForwardRef as ReactComponent };